import { Box } from '@mui/material';
import AgreementButtons from './AgreementButtons';
import AgreementPriceTable from './AgreementPriceTable';

export const AgreementPrices = () => {
    return (
        <Box
            style={{
                paddingLeft: '1rem'
            }}
        >
            <AgreementButtons />
            <AgreementPriceTable />
        </Box>
    );
};
